/* eslint-disable import/prefer-default-export */
import { isMobile } from "react-device-detect"

const googleAnalyticsConfig = {
    measurementIds: [isMobile ? "G-Z5K17ND6DS" : "G-SNV63PES97"]
}

export default googleAnalyticsConfig
